import { useCallback } from "react"
import { useSignal } from "@preact/signals-react"
import { useToastSeeker } from "@app"
import { deleteSubmit, getSubmit, postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS, SERVICES_TYPE } from "@constants"
import { isEditUserSettingsTierDrawer, isLoadingUserSettingTierData, userSettingsTierFormData, userSettingTierData } from "../@signals"


export default function useUserSettingsTier(rowData={}) {
	const { showToast } = useToastSeeker()
	const isLoading = useSignal(false)

	const getTiersData = useCallback(() => {
		getSubmit(`${BACKEND_APIS.CRUD}/user/tier`)
			.then(data => userSettingTierData.value = data)
			.catch(() => {
				showToast.error()
				userSettingTierData.value = []
			}).finally(() => isLoadingUserSettingTierData.value = false)
	}, [])

	const handleSetTierFormData = useCallback(() => userSettingsTierFormData.value = {
		id: rowData.id || null,
		service_type: SERVICES_TYPE.TIER,
		name: rowData.name || "My Tier",
		providers: rowData.providers || []
	}, [JSON.stringify(rowData)])

	const handleChangeTierFormData = useCallback((newValue, prop) => userSettingsTierFormData.value = {
		...userSettingsTierFormData.value,
		[prop]: newValue
	}, [])

	const handleSubmitTierFormData = useCallback(() => {
		isLoading.value = true
		postSubmit(`${BACKEND_APIS.CRUD}/${!isEditUserSettingsTierDrawer.value ? 'add' : 'update'}`, userSettingsTierFormData.value).then(res => {
			if (isEditUserSettingsTierDrawer.value) {
				userSettingTierData.value = [
					...userSettingTierData.value.map(item => item.id === userSettingsTierFormData.value.id ? res : item)
				]
			} else {
				userSettingTierData.value = [
					...userSettingTierData.value,
					res
				]
			}
			userSettingsTierFormData.value = {}
		}).catch(() => showToast.error())
			.finally(() => isLoading.value = false)
	}, [])

	const handleDeleteTier = useCallback(() => showToast.confirm(`Are you sure you want to delete this row? This action cannot be undone.`, {
		onSubmit: () => {
			isLoading.value = true
			deleteSubmit(`${BACKEND_APIS.CRUD}/delete/${SERVICES_TYPE.TIER}?id=${rowData.id}`).then(() => {
				userSettingTierData.value = [
					...userSettingTierData.value.filter(item => item.id !== rowData.id)
				]
			}).catch(() => showToast.error())
				.finally(() => isLoading.value = false)
		}
	}), [JSON.stringify(rowData)])

	return {
		isClicked: rowData.id === userSettingsTierFormData.value.id,
		isLoading: isLoading.value,
		getTiersData,
		handleSetTierFormData,
		handleChangeTierFormData,
		handleSubmitTierFormData,
		handleDeleteTier
	}
}